/* What a service is drawn with, mirrored.
 *
 * This is a COPY of `serviceAbbrev` from ../../../js/rules/services.js, for the
 * same reason `theme-presets.js` beside it is a copy: the admin app is its own
 * npm project (see admin/README.md) and does not reach across into the
 * console's source tree. Unlike that one this is four lines with no data behind
 * it, so the debt is small — but it is written down rather than left to be
 * discovered.
 *
 * The rule it restates: the hotkey on `tt_services.shortcut` is OPTIONAL and
 * nullable, so the label falls back twice — to the key where there is one, and
 * to the service's own name where there is not. Without the second step a salon
 * that books entirely by mouse gets a page of blank discs.
 *
 * If the console's version gains a step, this one is wrong in a visible way: the
 * admin draws a different letter from the board for the same service. There is
 * no silent failure mode, and no way for this file to hand anybody a value the
 * console would not accept.
 */
export function serviceAbbrev(abbrev, name, shortcut) {
  var set = String(abbrev == null ? '' : abbrev).trim().slice(0, 2);
  if (set) return set;
  var key = String(shortcut == null ? '' : shortcut).trim().toUpperCase().charAt(0);
  if (key) return key;
  return String(name == null ? '' : name).trim().charAt(0).toUpperCase() || '?';
}
